import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { ProjectionPage } from "@/features/domain/components/projection-page";
import { useI18n } from "@/providers/i18n-provider";

function ProjectionRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Projection`)}
      description={t(msg`Sign in to see the items you are allowed to project.`)}
    >
      <PageContainer maxWidth="3xl">
        <ProjectionPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const projectionRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/projection",
  component: ProjectionRoutePage,
});
